import { BaseEntity } from 'entities'
import { Equipment } from './equipment'
import { User } from './user'

export type TemperatureLedgerMaster = BaseEntity & {
    year?: string
    month?: string
    proofreading?: string
    controlTemperatureMax?: number
    controlTemperatureMin?: number
    controlHumidityMax?: number
    controlHumidityMin?: number
    maintenanceCompany?: string
    message?: string
    monthlyTemperatureLedgers?: MonthlyTemperatureLedger[]
    inspectTemperatureLedgers?: InspectTemperatureLedger[]
    equipment?: Equipment
    equipmentId?: number
}

export type TemperatureLedgerForm = TemperatureLedgerMaster

export type TemperatureLedgerSearchForm = TemperatureLedgerMaster

export type MonthlyTemperatureLedger = BaseEntity & {
    day?: number
    time?: string
    humidityAtMeasurement?: number
    humidityMin?: number
    humidityMax?: number
    temperatureAtMeasurement?: number
    temperatureMin?: number
    temperatureMax?: number
    user?: User
    userId?: number
    memo?: string
    temperatureLedgerMasterId?: number
    equipment?: Equipment
    equipmentId?: number
    isChecked?: boolean
    date?: string
}

export type MonthlyTemperatureLedgerForm = MonthlyTemperatureLedger & {
    isChecked?: boolean
}

export type MonthlyTemperatureLedgerSearchForm = MonthlyTemperatureLedger

export type InspectTemperatureLedger = BaseEntity & {
    temperatureLedgerMasterId?: number
    date?: string
    user?: User
    userId?: number
    content?: string
    message?: string
}

export type InspectTemperatureLedgerForm = InspectTemperatureLedger

export type InspectTemperatureLedgerSearchForm = InspectTemperatureLedger

export const InspectTemperatureLedgerRow = 2
